import { createFileRoute } from '@tanstack/react-router'
import { QueryGuard } from '../../components/query-guard'
import { ProfileEdit } from '../../features/profile/components/profile-edit'
import { ProfileView } from '../../features/profile/components/profile-view'
import { useCurrentUserQuery, useInvestorQuery, useStartupQuery } from '../../hooks/api'
import { useEditMode } from '../../hooks/use-edit-mode'
import { useIsFounder, useIsInvestor } from '../../hooks/use-user-type'

export const Route = createFileRoute('/_protected/profile')({
  component: ProfileComponent,
})

function ProfileComponent() {
  const { isEditMode, startEditing, stopEditing } = useEditMode()
  const userQuery = useCurrentUserQuery()
  const isFounder = useIsFounder()
  const isInvestor = useIsInvestor()

  const { data: startupResponse } = useStartupQuery({ enabled: isFounder })
  const { data: investorResponse } = useInvestorQuery({ enabled: isInvestor })

  return (
    <QueryGuard query={userQuery} errorMessage="Failed to load profile">
      {(user) =>
        isEditMode ? (
          <ProfileEdit onExitEdit={stopEditing} />
        ) : (
          <ProfileView
            user={user}
            canEdit={true}
            onEdit={startEditing}
            startup={startupResponse?.data ?? null}
            investor={investorResponse?.data ?? null}
          />
        )
      }
    </QueryGuard>
  )
}
